// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","anchor":"App_anchor__FMa8f","projects":"App_projects__Zy67d"};